/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/corvette_2': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 12.336V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086h8.086L16 31.414l3.664-3.664h8.086v-8.086L31.414 16l-3.664-3.664zm-.5-7.586v7.086L20.164 4.75h7.086zm-22.5 0h7.086L4.75 11.836V4.75zm0 22.5v-7.086l7.086 7.086H4.75zm22.5 0h-7.086l7.086-7.086v7.086zM16 28.586L3.414 16 16 3.414 28.586 16 16 28.586z"/><path pid="1" d="M13.333 18L12 20.667h3.333V22h1.334v-1.333H20L18.667 18zM18.667 14.667C18.667 12 16 10 16 10s-2.667 2-2.667 4.667v2.666h5.334v-2.666zM18.833 12.667c.5.666.5 1.333.5 2V18l.334.667H20v-6h-1.167zM12.667 18v-3.333c0-.667 0-1.334.5-2H12v6h.333l.334-.667z"/>'
  }
})
